import { reactive, toRefs } from '@vue/composition-api';

const useModal = () => {
  const state = reactive({
    isOpen: false,
    component: false,
    props: null
  });

  const handleOpen = (component, props) => {
    state.isOpen = true;
    state.props = props;
    state.component = component.default;
  };

  const handleClose = () => {
    state.isOpen = false;
    state.props = null;
    state.component = false;
  };

  return {
    ...toRefs(state),
    handleOpen,
    handleClose
  };
};

export default useModal;
